exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".employeeCellAvatar-896a0{margin-right:15px}", ""]);

// Exports
exports.locals = {
	"employeeCellAvatar": "employeeCellAvatar-896a0"
};